import { Injectable } from '@angular/core';
import { ILayoutAssignment } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { SortLayoutAssignmentGateway } from './sort-layout-assignment.gateway';

@Injectable({ providedIn: 'root' })
export class SortLayoutAssignmentStore {
  private readonly gateway: SortLayoutAssignmentGateway =
    new SortLayoutAssignmentGateway();

  async saveAll(
    layoutAssignments: ILayoutAssignment[]
  ): Promise<ILayoutAssignment[]> {
    const response: IApiResponse<ILayoutAssignment[]> = await firstValueFrom(
      this.gateway.save(layoutAssignments)
    );

    return response.data ?? [];
  }
}
